// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import { closeNotificationAction } from '../../action/notifications';

const styles = (theme) => ({});

type Props = {
  notifications: Array<NotificationType>,
  closeNotification: Function,
};

type State = {};

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

class SnackbarNotifications extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {

  }

  handleClose = (key) => () => {
    this.props.closeNotification(key);
  };

  render() {
    const { notifications } = this.props;
    return (
      <>
        {notifications.map((n) => (
          <Snackbar
            key={`notification-${n.key}`}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={n.open}
            autoHideDuration={5000}
            onClose={this.handleClose(n.key)}
            message={n.message}
            action={n.action}
            transitionDuration={{
              enter: 500,
              exit: 500,
            }}
            TransitionComponent={TransitionUp}
          />
        ))}
      </>
    );
  }
}

const mapStateToProps = (state: Object) => ({
  notifications: state.notifications,
});

const mapDispatchToProps = (dispatch) => ({
  closeNotification: (key) => dispatch(closeNotificationAction(key)),
});

// eslint-disable-next-line
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SnackbarNotifications));
